import React from "react";
import "swiper/css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import { useState } from "react";
import { Button, Grid, makeStyles } from "@material-ui/core";
import Apis from "constants/Api";

// SwiperCore.use([Navigation, Pagination]);

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: 60,
    marginBottom: 100,
  },
  title: {
    fontSize: 24,
    fontWeight: "bold",
    marginBottom: 30,
  },
  box: {
    // minHeight: "min(730px,65vw)",
  },
  maxWidth1024: {
    [theme.breakpoints.up("md")]: {
      maxWidth: "1042px",
      padding: "30px 50px",
    },
    position: "relative",
    backgroundColor: "#e5e5e5",
    borderRadius: "25px",
    marginBottom: "40px",
    "& .swiper": {
      width: "100%",
      paddingBottom: "100px",
      [theme.breakpoints.down("sm")]: {
        padding: "0 10px",
        paddingBottom: 110,
        paddingTop: "35px",
      },
    },
    "& .swiper-slide": {
      height: "fit-content",
    },
    "& .swiper-wrapper": {
      height: "fit-content",
    },
    "& .swiper-pagination.swiper-pagination-bullets.swiper-pagination-horizontal":
      {
        bottom: "75px !important",
        left: "2px !important",
      },
    "& .swiper-pagination .swiper-pagination-bullet-active": {
      backgroundColor: "#00000099 !important",
    },
    "& .swiper-button-next": {
      [theme.breakpoints.down("sm")]: {
        top: "93% !important",
        left: "53% !important",
      },
      left: "51% !important",
      top: "97% !important",
      backgroundColor: "#fff",
      width: 45,
      borderRadius: "100%",
    },
    "& .swiper-button-prev": {
      [theme.breakpoints.down("sm")]: {
        top: "93% !important",
        left: "35.5% !important",
      },
      left: "44.5% !important",
      top: "97% !important",
      backgroundColor: "#fff",
      width: 45,
      borderRadius: "100%",
    },
    "& .swiper-button-next::after": {
      color: "#2dbbc0",
      fontWeight: "bold",
      fontSize: 19,
    },
    "& .swiper-button-prev::after": {
      color: "#2dbbc0",
      fontWeight: "bold",
      fontSize: 19,
    },
  },
  notifButton: {
    backgroundColor: "#ffffff",
    borderRadius: "14px",
    fontSize: "20px",
    padding: "5px 15px",
    position: "absolute",
    zIndex: "100",
    right: "35px",
    bottom: "35px",
    cursor: "pointer",
    "&:hover": {
      boxShadow: "0 0 20px 0  #00000040",
      transition: "all 200ms linear",
      backgroundColor: "#ffffff50",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "3px 12px",
      fontSize: "13px",
      right: "3vw",
      bottom: "15px",
    },
  },
}));
export function ImageSlider({ data, setStep, setSecondStepData }) {
  console.log(data?.banner, "data");
  const classes = useStyles();
  const handleNotif = (secondData) => {
    setSecondStepData(secondData);
    setStep(2);
  };
  return (
    <Grid container className={classes.box}>
      <Grid container justify="center">
        <Grid container className={classes.maxWidth1024}>
          <Swiper
            spaceBetween={20}
            pagination
            breakpoints={{
              0: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              // 410: {
              // 	slidesPerView: 2.12,
              // },
              // 1200: {
              // 	slidesPerView: 3.4,
              // },
              // 1400: {
              // 	slidesPerView: 4.4,
              // },
              // 1800: {
              // 	slidesPerView: 5.3,
              // },
            }}
            rtl
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
          >
            {data?.banner?.length > 0 &&
              data?.banner?.map((item, index) => (
                <SwiperSlide key={item.id + index}>
                  <Grid
                    container
                    style={{
                      borderRadius: "25px",
                      position: "relative",
                      minHeight: 300,
                    }}
                  >
                    <img
                      src={Apis.imageUrl + item?.image_url}
                      alt="banner"
                      style={{
                        width: "100%",
                        borderRadius: "30px",
                      }}
                    />
                    <Button
                      className={classes.notifButton}
                      onClick={() => handleNotif(item)}
                    >
                      مشاهده اطلاعیه
                    </Button>
                  </Grid>
                </SwiperSlide>
              ))}
            {data?.banner?.length > 0 && (
              <Grid className="swiper-button-prev"></Grid>
            )}
            {data?.banner?.length > 0 && (
              <Grid className="swiper-button-next"></Grid>
            )}
          </Swiper>
        </Grid>
      </Grid>
    </Grid>
  );
}
